module.exports = __webpack_public_path__ + "img/semi-ajoure.fe0715d.svg";